import { Injectable } from '@angular/core';
import { app } from '@microsoft/teams-js';
import type { SafeAny } from '@project-hub/types';
import { BehaviorSubject } from 'rxjs';
import { inTeams } from '../helpers/teams.helper';

@Injectable({
  providedIn: 'root',
})
export class TeamsService {
  private theme = new BehaviorSubject<string>('web');
  public readonly theme$ = this.theme.asObservable();

  get teamsContext(): Promise<app.Context | undefined> {
    return app?.getContext();
  }

  async init() {
    const setTheme = (theme: string) => {
      switch (theme) {
        case 'dark':
        case 'contrast':
          this.theme.next('teams-dark');
          break;
        default:
          this.theme.next('web');
          break;
      }
    };
    if (inTeams()) {
      console.log('Initialize Auth & Theme in Teams');
      try {
        await app.initialize();
        const context = await this.teamsContext;
        setTheme(`${context?.app?.theme}`);
        app.registerOnThemeChangeHandler((theme) => setTheme(theme));
        await app.notifySuccess();
        return true;
      } catch (e: SafeAny) {
        console.error(e);
        app.notifyFailure({
          reason: app.FailedReason.AuthFailed,
          message: e.message,
        });
        return false;
      }
    } else {
      console.log('Initialize Theme in Web');
      const query = window.matchMedia('(prefers-color-scheme: dark)');
      setTheme(query.matches ? 'dark' : 'light');
      query.addEventListener('change', (event) => {
        setTheme(event.matches ? 'dark' : 'light');
      });
      return true;
    }
  }
}
